// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1V72q","footer":"ModalFilter_footer__2Wcw-"};